import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  currentUser: {},
  legacyUser: {},
  isEligibleForOffers: false,
  isAuthenticated: false,
  saveError: null,
  saveLoading: false,
  userJwt: null,
  AccountLastModified: null,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
